var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgRightArrow = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9236 10.4906L12.9236 10.4906L12.9248 10.4895C13.0662 10.3568 13.15 10.1923 13.15 10C13.15 9.81041 13.0683 9.63848 12.9228 9.50861L8.06475 5.03938L8.06476 5.03936L8.06271 5.03754C7.924 4.91453 7.75332 4.85 7.55828 4.85C7.17272 4.85 6.85 5.132 6.85 5.52419C6.85 5.71178 6.92996 5.88149 7.05357 6.00481L7.05348 6.0049L7.05805 6.0091L11.404 10L7.05805 13.9909L7.05797 13.9908L7.05357 13.9952C6.93063 14.1178 6.85 14.2816 6.85 14.4758C6.85 14.868 7.17272 15.15 7.55828 15.15C7.75342 15.15 7.92553 15.0853 8.06524 14.9544C8.06545 14.9542 8.06566 14.954 8.06587 14.9538L12.9236 10.4906Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRightArrow);
export default ForwardRef;